import { render, staticRenderFns } from "./CabeceraModalDevolucionVista.vue?vue&type=template&id=666c9645&scoped=true&"
import script from "./CabeceraModalDevolucionVista.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalDevolucionVista.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalDevolucionVista.vue?vue&type=style&index=0&id=666c9645&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c9645",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('666c9645', component.options)
    } else {
      api.reload('666c9645', component.options)
    }
    module.hot.accept("./CabeceraModalDevolucionVista.vue?vue&type=template&id=666c9645&scoped=true&", function () {
      api.rerender('666c9645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Devoluciones/CabeceraModalDevolucionVista.vue"
export default component.exports